import { Add } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { QuestionCard } from "../mobilePreview.style";

const UploadFilePreview = () => {
  return (
    <Box sx={QuestionCard}>
      <Box
        sx={{
          borderRadius: "12px",
          border: 2,
          borderColor: "divider",
          borderStyle: "dashed",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          height: "160px",
        }}
      >
        <Add color="primary" />
        <Typography variant="subtitle1" fontWeight="medium" color="primary">
          Upload file
        </Typography>
        <Typography variant="subtitle1" fontWeight="medium" color="primary">
          (max 5MB)
        </Typography>
      </Box>
    </Box>
  );
};

export default UploadFilePreview;
